// @flow
import { generateSchema } from "src/utils/schemaUtils";
import { recordInput } from "src/models/RiskModel";
export default generateSchema([], {
  recordInput
});
